import { components } from 'react-select'
import { injectIntl } from 'react-intl'
import messages from '../messages'

function ClearIndicator(props) {
  return (
    <components.ClearIndicator
      {...props}
      innerProps={{
        ...props.innerProps,
        'aria-label': props.intl.formatMessage(messages.clear),
      }}
    />
  )
}

export default injectIntl(ClearIndicator)
